import { useState } from 'react';

export interface AuthState {
  email: string;
  vendorCompanyCode: string;
  receivingCompanyCode: string;
  isRegistered: boolean;
  // v0.15: OTP 検証で受け取った本人確認トークン（請求書提出などの API に必須）
  token: string;
}

const SESSION_KEY = 'invoice_auth';

export const useAuth = () => {
  const [auth, setAuth] = useState<AuthState | null>(() => {
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (!stored) return null;
    try {
      const parsed = JSON.parse(stored) as AuthState;
      // v0.15 以前のログイン状態（トークン無し）は無効扱い＝ログインし直してもらう
      if (!parsed?.token) { sessionStorage.removeItem(SESSION_KEY); return null; }
      return parsed;
    } catch {
      sessionStorage.removeItem(SESSION_KEY);
      return null;
    }
  });

  const login = (state: AuthState) => {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
    setAuth(state);
  };

  const logout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    setAuth(null);
  };

  return { auth, login, logout };
};
